import { useEffect, useState } from "react";

function App() {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  // Get current path to determine which page to load
  const getPageToLoad = () => {
    const path = window.location.pathname;
    const search = window.location.search;
    
    if (path.includes("results.html")) {
      return `/api/page/results.html${search}`;
    }
    if (path.includes("detailed-report.html")) {
      return `/api/page/detailed-report.html${search}`;
    }
    return "/api/page/prosthetic-home.html";
  };

  useEffect(() => {
    // Redirect directly to the static HTML pages served by backend
    const path = window.location.pathname;
    const search = window.location.search;
    
    if (path === "/" || path === "/index.html") {
      // For homepage, redirect to backend-served page
      window.location.href = "/api/page/home" + search;
    } else if (path.includes("results.html")) {
      window.location.href = "/api/page/results" + search;
    } else if (path.includes("detailed-report.html")) {
      window.location.href = "/api/page/detailed-report" + search;
    }
  }, []);

  return (
    <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      height: "100vh",
      background: "#0B1F3A",
      color: "#00C9B1",
      fontFamily: "DM Sans, sans-serif"
    }}>
      Redirecting...
    </div>
  );
}

export default App;
